import React from 'react';
import styled from 'styled-components';
import { Typo, Icon } from 'tmt-ui-kit';
import PropTypes from 'prop-types';

const Title = styled(Typo.HeaderThree)`
  font-size: 18px !important;
  color: ${props => props.theme.orange} !important;
  margin: 0;
  margin-bottom: 16px;
`;

const Container = styled.div`
  ${props => props.white && `
    background-color: ${props.theme.white};
    padding: 16px 12px 12px 12px;
    border-radius: 6px;
  `}
`;

const RemarkTitle = styled(Typo.Paragraph)`
  color: ${props => props.theme.orange} !important;
  font-size: 16px !important;
  font-weight: 500 !important;
  margin: 0;
  margin-bottom: 4px;
`;

const Text = styled(Typo.Paragraph)`
  margin: 0;
`;

const RemarkItem = styled.div`
  display: flex;
  margin-bottom: 16px;
`;

const IconBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
  width: 44px;
  height: 44px;
  border-radius: 6px;
  border: 1px solid ${props => props.theme.blueGray};
  ${Icon} {
    font-size: 26px;
    color: ${props => props.theme.orange};
  }
`;

const Remark = (props) => {
  const { type } = props;
  return (
    <Container white={type === 'restaurant'}>
      <Title>Remarks</Title>
      <div>
        <RemarkItem>
          <div>
            <IconBox><Icon name="seasonal" /></IconBox>
          </div>
          <div>
            <RemarkTitle>Seasonality</RemarkTitle>
            <Text>All menu items are subject to seasonal availability.</Text>
          </div>
        </RemarkItem>
        <RemarkItem>
          <div>
            <IconBox><Icon name="warning" /></IconBox>
          </div>
          <div>
            <RemarkTitle>Allergies/Restrictions</RemarkTitle>
            <Text>Please always inform your Local Expert of your food allergies and dietary restrictions.</Text>
          </div>
        </RemarkItem>
      </div>
    </Container>
  );
};

Remark.propTypes = {
  type: PropTypes.string
};

export default Remark;
